import React, { Component } from "react";
import "./style.scss";
import {
  NormalButton,
  NormalInput,
  NormalSelect,
  InputSearch,
  NormalModal,
  TableWrapper,
  NormalMultiSelect,
  SearchInputKeyboard,
  NormalTextarea,
} from "component/common";
import { Toast } from "service/toast";
import { dateFormat } from "service/helperFunctions";
import _ from "lodash";
import { history } from "helpers";
import { connect } from "react-redux";
import Tree from "react-animated-tree";
import { bindActionCreators } from "redux";
import {
  getCommonApi,
  updateForm,
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
} from "redux/actions/common";
import SimpleReactValidator from "simple-react-validator";
// import { Treatment, Payment, EditCart } from './cart/index';
import service from "assets/images/make-up-brush.png";
// import Discount from './cart/discount';
import { StaffList } from "./StaffList";
import { withTranslation } from "react-i18next";
import { NumPadKeyboard } from "component/common/NumPadKeyboard";
import { CustomerGroups } from "redux/actions/Backend";
export class CourseTreatmentDoneClass extends Component {
  state = {
    isOpen: false,
    currentIndex: -1,
    tstaffList: [],
    cartData: {},
    postFields: {
      work_point: "",
    },
    Room: null,
    Source: null,
    new_remark: null,
    updateFields: {
      Room_Codeid: "",
      Source_Codeid: "",
      new_remark: "",
    },
    outletList: [],
    headerDetails: [
      { label: "Employee Name", sortKey: false, width: "130px" },
      { label: "Session", width: "30px", divClass: "justify-content-center" },
      { label: "WP1", width: "42px", divClass: "justify-content-center" },
      { label: "Percent", width: "42px", divClass: "justify-content-center" },
      { label: "Amount", width: "42px", divClass: "justify-content-center" },
      // {
      //   label: "St.time",
      //   sortKey: false,
      //   width: "55px",
      //   divClass: "justify-content-center",
      // },
      // {
      //   label: "End Time",
      //   sortKey: false,
      //   width: "55px",
      //   divClass: "justify-content-end text-right",
      // },
      // {
      //   label: "Duration",
      //   sortKey: false,
      //   width: "55px",
      //   divClass: "justify-content-center",
      // },
    ],
    sessionTableHeader: [
      { label: "Session", width: "30px", divClass: "justify-content-center" },
      { label: "Employee" },
      { label: "" },
    ],
    sessionTableDetails: [],
    employeeOptions: [],
    customerOption: [],
    // cartData: {},
    roomList: [],
    sourceList: [],
    staffList: [],
    duration: [],
    startDuration: [],
    showPostError: false,
    showUpdateError: false,
    staffData: {},
    page: 1,
    limit: 7,
    hideNotNeededControls: "false",
    meta: {},
    searchStaffInput: "",
    treatementRemarks: "",
    total_percentage: 0,
    percentage_calculate: 0,
    updatedPercentValue: "",
    updatedWork_Am_tValue: "",
    hours: null,
    minutes: null,
    classOptions: [],
    selectedClass: "",
  };

  componentDidMount = () => {
    // this.getCart();
    console.log(this.props, "coursetreatmentdoneprops");
    this.validator = new SimpleReactValidator({
      element: (message) => (
        <span className="error-message text-danger validNo fs14">
          {message}
        </span>
      ),
      autoForceUpdate: this,
    });

    let {
      roomList,
      sourceList,
      staffList,
      cartData,
      duration,
      startDuration,
      tstaffList,
    } = this.state;
    this.props.getCommonApi("room/").then((key) => {
      let { status, data } = key;
      for (let value of data) {
        roomList.push({ value: value.id, label: value.displayname });
      }
      this.setState({ roomList });
    });
    this.props.getCommonApi(`source/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          sourceList.push({ value: value.id, label: value.source_desc });
        }
        this.setState({ sourceList });
      }
    });
    this.getStaffList();
    this.getCart();

    const startDurationLocal = [
      "08:00",
      "08:10",
      "08:20",
      "08:30",
      "08:40",
      "08:50",
      "09:00",
      "09:10",
      "09:20",
      "09:30",
      "09:40",
      "09:50",
      "10:00",
      "10:10",
      "10:20",
      "10:30",
      "10:40",
      "10:50",
      "11:00",
      "11:10",
      "11:20",
      "11:30",
      "11:40",
      "11:50",
      "12:00",
      "12:10",
      "12:20",
      "12:30",
      "12:40",
      "12:50",
      "13:00",
      "13:10",
      "13:20",
      "13:30",
      "13:40",
      "13:50",
      "14:00",
      "14:10",
      "14:20",
      "14:30",
      "14:40",
      "14:50",
      "15:00",
      "15:10",
      "15:20",
      "15:30",
      "15:40",
      "15:50",
      "16:00",
      "16:10",
      "16:20",
      "16:30",
      "16:40",
      "16:50",
      "17:00",
      "17:10",
      "17:20",
      "17:30",
      "17:40",
      "17:50",
      "18:00",
      "18:10",
      "18:20",
      "18:30",
      "18:40",
      "18:50",
      "19:00",
      "19:10",
      "19:20",
      "19:30",
      "19:40",
      "19:50",
      "20:00",
      "20:10",
      "20:20",
      "20:30",
      "20:40",
      "20:50",
      "21:00",
      "21:10",
      "21:20",
      "21:30",
      "21:40",
      "21:50",
      "22:00",
      "22:10",
      "22:20",
      "22:30",
      "22:40",
      "22:50",
      "23:00",
    ];
    //this.props.getCommonApi(`treatment/Duration/`).then((key) => {
    //let { status, data } = key;
    //if (status === 200) {
    this.props.getCommonApi(`treatment/Duration/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          duration.push({ value: value, label: value });
        }
        this.setState({ duration });
      }
    });
    for (let value of startDurationLocal) {
      startDuration.push({ value: value, label: value });
    }
    this.setState({ duration, startDuration });
    //}
    //})

    //this.setState({ duration:durationLocal })

    if (this.props.tokenDetails?.sportsclass) {
      this.getClasses();
    }
  };

  getClasses = async () => {
    this.props.CustomerGroups().then((res) => {
      let newOptions = res?.map((list) => ({
        label: list.groupDesc,
        value: list.groupCode,
      }));
      this.setState({
        classOptions: newOptions,
      });
    });
  };
  getCart = (handlePercent) => {
    let {
      roomList,
      sourceList,
      staffList,
      cartData,
      duration,
      tstaffList,
      employeeOptions,
      hours,
      minutes,
    } = this.state;
    if (cartData?.value?.type === "H") {
      console.log("running");
      let newHours = hours * 60 + minutes;
      this.props
        //.getCommonApi(`coursetmpitemhelper/?cart_id=5470&done=2&deposit=680`)
        .getCommonApi(
          `coursetmpitemhelper/?cart_id=${this.props.cartId}&done=${
            // newHours === 0 ? 1 : newHours
            1
          }&deposit=${this.props.depositAmt}`
        )
        .then(async (key) => {
          cartData = key;
          if (this.state.treatementRemarks || key?.value?.remarks) {
            console.log(
              "this.state.treatementRemarks,",
              this.state.treatementRemarks,
              key?.value?.remarks
            );
            await this.setState({
              treatementRemarks:
                key?.value?.remarks || this.state.treatementRemarks,
            });
          }
          await this.setState({
            tstaffList: [],
            employeeOptions: [],
            sessionTableDetails: [],
          });
          if (handlePercent) {
            this.setState({ tstaffList: key.data });
          } else {
            tstaffList = [];
            let remainingPercentage = 100;
            let remainingAmount = Number(cartData.value.Price);

            tstaffList = key.data.map((list, index) => {
              let percent;

              // if (index === 0 && list.percent === "100") {
              //   percent = "100";
              // } else {
              percent = (
                remainingPercentage /
                (key.data.length - index)
              ).toFixed(2);
              // list.percent !== ""
              //   ? list.percent
              //   : (remainingPercentage / (key.data.length - index)).toFixed(2);
              // }

              let workAmt = (
                remainingAmount /
                (key.data.length - index)
              ).toFixed(2);
              // list.percent !== ""
              //   ? (remainingAmount * (percent / 100)).toFixed(2)
              //   : (remainingAmount / (key.data.length - index)).toFixed(2);

              remainingPercentage -= parseFloat(percent);
              remainingAmount -= parseFloat(workAmt);

              return {
                ...list,
                percent,
                work_amt: workAmt,
              };
            });
          }

          employeeOptions = [];
          tstaffList.forEach((e) => {
            employeeOptions.push({ label: e.helper_name, value: e.helper_id });
          });
          this.setState({
            treatementRemarks:
              key?.value?.remarks || this.state.treatementRemarks,
            cartData,
            tstaffList,
            employeeOptions,
          });
          this.getDataFromRes(key);
          this.setState({
            total_percentage: cartData.value.Price,
          });
        });
    } else {
      console.log("this");

      let sessionCount = this.props.sessionCount ? this.props.sessionCount : 1;
      let apiUrl = `coursetmpitemhelper/?cart_id=${this.props.cartId}&done=${sessionCount}&deposit=${this.props.depositAmt}`;

      // if (sessionCount && sessionCount % 1 !== 0) {
      //   apiUrl += `&decimal_value=${true}`

      // }
      this.props
        //.getCommonApi(`coursetmpitemhelper/?cart_id=5470&done=2&deposit=680`)
        .getCommonApi(apiUrl)
        .then(async (key) => {
          cartData = key;
          if (this.state.treatementRemarks || key?.value?.remarks) {
            console.log(
              "this.state.treatementRemarks,",
              this.state.treatementRemarks,
              key?.value?.remarks
            );
            await this.setState({
              treatementRemarks:
                key?.value?.remarks || this.state.treatementRemarks,
            });
          }
          await this.setState({
            tstaffList: [],
            employeeOptions: [],
            sessionTableDetails: [],
          });
          if (handlePercent) {
            this.setState({ tstaffList: key.data });
          } else {
            tstaffList = key.data;
            let actualSession = parseFloat(this.props.sessionCount);
            let remainingPercentage = this.props.sessionCount * 100;
            let remainingAmount = Number(cartData.value.Price);
            let remainingSession = actualSession;

            let totalSessions = 0;
            for (var i = 0; i < key.data.length; i++) {
              totalSessions += parseFloat(key?.data[i]?.session);
            }
            tstaffList = key.data.map((list, index) => {
              let percent;
              let session;

              session = (remainingSession / (key.data.length - index)).toFixed(
                2
              );
              percent = (
                remainingPercentage /
                (key.data.length - index)
              ).toFixed(2);

              let workAmt = (
                remainingAmount /
                (key.data.length - index)
              ).toFixed(2);

              remainingPercentage -= parseFloat(percent);
              remainingAmount -= parseFloat(workAmt);
              remainingSession -= parseFloat(session);
              return {
                ...list,
                percent,
                session,
                work_amt: workAmt,
              };
            });
          }

          employeeOptions = [];
          tstaffList.forEach((e) => {
            employeeOptions.push({ label: e.helper_name, value: e.helper_id });
          });
          this.setState({
            treatementRemarks:
              key?.value?.remarks || this.state.treatementRemarks,
            cartData,
            tstaffList,
            employeeOptions,
          });
          this.getDataFromRes(key);
          this.setState({
            total_percentage: cartData.value.Price,
          });
        });
    }
  };

  getDataFromRes = async (key) => {
    let { postFields, updateFields } = this.state;
    postFields["work_point"] = key.value.work_point ? key.value.work_point : "";
    updateFields["Room_Codeid"] = key.value.room_id ? key.value.room_id : "";
    updateFields["Source_Codeid"] = key.value.source_id
      ? key.value.source_id
      : "";
    updateFields["new_remark"] = key.value.new_remark
      ? key.value.new_remark
      : "";
    await this.setState({
      postFields,
      updateFields,
    });
  };

  handleSubmit = (id) => {
    console.log(
      "this.state.updateFields.Source_Codeid",
      this.state.updateFields.Source_Codeid
    );

    let { tstaffList, formFields, cartData, postFields, hours, minutes } =
      this.state;
    let xTotalWp1Amount = 0;
    for (var i = 0; i < this.state.tstaffList.length; i++) {
      xTotalWp1Amount += parseFloat(this.state.tstaffList[i].wp1);
    }
    if (parseFloat(xTotalWp1Amount) == parseFloat(postFields.work_point)) {
    } else {
      Toast({
        type: "error",
        message: "User Entry should not greater or lesser than Work point",
      });
      return;
    }
    const totalPercent =
      this.state.tstaffList.length > 0 &&
      this.state.tstaffList.reduce(
        (total, item) => total + Number(item.percent),
        0
      );
    const isTotalPercent100 = totalPercent === this.props.sessionCount * 100;

    let totalSession = 0;
    for (var i = 0; i < this.state.tstaffList.length; i++) {
      totalSession += parseFloat(this.state.tstaffList[i].session);
    }
    const isTotalSession = totalSession == this.props.sessionCount;

    if (!isTotalSession) {
      return alert(`the total session should be ${this.props.sessionCount}`);
    }
    if (!isTotalPercent100) {
      return alert(
        `the total percentage should be ${this.props.sessionCount * 100}%`
      );
    }
    let remaksValue = this.state.treatementRemarks;
    if (cartData?.value?.type === "H") {
      let newHours = hours * 60 + minutes;
      localStorage.setItem("courseDuration", newHours);
      localStorage.removeItem("duration");
      this.props
        .getCommonApi(
          `coursetmpitemhelper/confirm/?cart_id=${this.props.cartId}&done=${
            // newHours === 0 ? 1 : newHours
            1
          }&deposit=${this.props.depositAmt}&remarks=${remaksValue}&dur_qty=${
            newHours === 0 ? 1 : newHours
          }`
        )
        .then(async (key) => {
          let { status, message } = key;
          if (status == "200") {
            this.props.handleModal();
          }
        });
    } else {
      let empCode = tstaffList?.map((list) => list.helper_name);
      let empSessions = tstaffList?.map((list) => list?.session);
      let empAmount = tstaffList?.map((list) => list?.work_amt);
      let treatmentIds =
        this.props.treatmentId?.length > 0
          ? this.props.treatmentId?.sort((a, b) => b - a)
          : "";
      let apiUrl = `coursetmpitemhelper/confirm/?cart_id=${this.props.cartId}&done=${this.props.sessionCount}&deposit=${this.props.depositAmt}&remarks=${remaksValue}`;

      if (this.props.changeStaff) {
        apiUrl += `&treatmentid=${treatmentIds}&emp_code=${empCode}&session=${empSessions}&amount=${empAmount}`;
      }

      this.props.getCommonApi(apiUrl).then(async (key) => {
        let { status, message } = key;
        if (status == "200") {
          this.props.handleModal();
        }
      });
    }
  };

  handleDialog = () => {};

  handleAddstaff = (item) => {
    let { tstaffList, formFields, cartData, postFields } = this.state;
    let data = {
      helper_id: item.id,
    };
    if (postFields.work_point && postFields.times) {
      this.props
        .commonCreateApi(
          `coursetmpitemhelper/?cartid=${this.props.cartId}&workcommpoints=${postFields.work_point}&times=${postFields.times}`,
          data
        )
        .then((res) => {
          this.getCart();
        });
    } else {
      this.setState({ showPostError: true });
    }
  };

  handleuUpdateWp = async (event, item, index) => {
    // event.persist();
    let { postFields } = this.state;
    let workpoint = Number(postFields.work_point);
    let userEnteredValue = Number(event.target.value);
    if (userEnteredValue > workpoint) {
      return false;
    }

    let { tstaffList } = this.state;
    tstaffList[index][event.target.name] = event.target.value;
    await this.setState({
      tstaffList,
    });
    console.log(event, item, index, "sfdgfdgsgf too");
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async (event, item, index) => {
        console.log(event, item, index, "sfdgfdgsgf inside");
        this.handleUpdatestaff(event, item, index);
      }, 1000);
    }
    this.debouncedFn(event, item, index);
  };

  handleUpdateSession = async (event, item, index) => {
    // event.persist();
    let { postFields } = this.state;
    let sessionPoints = this.props.sessionCount;
    let userEnteredValue = parseFloat(event.target.value);
    if (userEnteredValue > sessionPoints) {
      return false;
    } else {
      let { tstaffList } = this.state;
      tstaffList[index][event.target.name] = event.target.value;
      await this.setState({
        tstaffList,
      });
    }
    console.log(event, item, index, "sfdgfdgsgf too");
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async (event, item, index) => {
        console.log(event, item, index, "sfdgfdgsgf inside");
        this.handleUpdatestaff(event, item, index);
      }, 1000);
    }
    this.debouncedFn(event, item, index);
  };

  handleUpdatestaff = async (event, item, index, amountPercentage) => {
    //this.state.updateFields.Source_Codeid="";
    let { tstaffList, cartData, updateFields } = this.state;
    let { Room_Codeid, Source_Codeid, new_remark } = updateFields;
    if (event.target.name !== "wp1" && event.target.name !== "session") {
      tstaffList[index][event.target.name] = event.target.value;
      this.setState({
        tstaffList,
      });
    }
    console.log(event, item, index, "sfdgfdgsgf");
    let data = {};
    if (event.target.name === "appt_fr_time") {
      data = {
        appt_fr_time: event.target.value,
        add_duration: cartData.value.add_duration,
        wp1: Number(item.wp1).toFixed(2),
      };
    }
    if (event.target.name === "add_duration") {
      data = {
        appt_fr_time: item.appt_fr_time,
        add_duration: event.target.value,
        wp1: Number(item.wp1).toFixed(2),
      };
    }
    if (event.target.name === "wp1") {
      data = {
        appt_fr_time: item.appt_fr_time,
        add_duration: cartData.value.add_duration,
        wp1: Number(item.wp1).toFixed(2),
      };
    }
    if (event.target.name === "percent") {
      data = {
        appt_fr_time: item.appt_fr_time,
        add_duration: cartData.value.add_duration,
        percent: Number(item.percent),
        work_amt: amountPercentage,
      };
    }
    if (event.target.name === "work_amt") {
      data = {
        appt_fr_time: item.appt_fr_time,
        add_duration: cartData.value.add_duration,
        work_amt: Number(item.work_amt).toFixed(2),
      };
    }
    if (event.target.name === "session") {
      data = {
        appt_fr_time: item.appt_fr_time,
        add_duration: cartData.value.add_duration,
        wp1: Number(item.wp1).toFixed(2),
        session: Number(item.session).toFixed(2),
      };
    }

    // if (updateFields.Source && updateFields.Room) {
    this.props
      .commonPatchApi(
        `coursetmpitemhelper/${item.id}/?Room_Codeid=${Room_Codeid}&Source_Codeid=${Source_Codeid}&new_remark=${new_remark}`,
        data
      )
      .then((res) => {
        if (res.status == 200) {
          console.log(res, "updatesessiononblur");
          this.getCart(amountPercentage);
        }
      });
    // } else {
    //     this.setState({ showUpdateError: true })
    // }
  };

  handleClearLine = () => {
    this.props
      //coursetmpitemhelper/delete/?clear_all=0&cart_id=5470&done=2
      .commonDeleteApi(
        `coursetmpitemhelper/delete/?clear_all=0&cart_id=${this.props.cartId}&done=${this.props.sessionCount}`
      )
      .then(() => {
        this.getCart();
      });
  };

  handleClearAll = () => {
    this.props
      .commonDeleteApi(
        `coursetmpitemhelper/delete/?clear_all=1&cart_id=${this.props.cartId}&done=${this.props.sessionCount}`
      )
      .then(() => {
        this.getCart();
      });
  };

  getStaffList = (data) => {
    let { page, limit, searchStaffInput } = this.state;
    this.props
      .getCommonApi(
        `empcartlist/?sales_staff=0&page=${page}&limit=${limit}&search=${searchStaffInput}`
      )
      .then(async (key) => {
        let { status, data } = key;
        console.log(key, "sdfgsdfgsdfgdfg sdfgsdfgsdfg");
        let { staffList } = this.state;
        let { meta } = this.state;
        staffList = [];
        meta = {};
        staffList = data;
        meta = data.meta.pagination;
        console.log(meta, "metalist");
        this.setState({
          staffList,
          meta,
        });
      });
  };
  handleNext = async () => {
    let { page } = this.state;
    page = page + 1;
    await this.setState({
      page,
    });
    if (page > 0) {
      this.getStaffList();
    }
  };

  handleBack = async () => {
    let { page } = this.state;
    page = page - 1;
    await this.setState({
      page,
    });
    if (page > 0) {
      this.getStaffList();
    }
  };

  handleSelect_Staff = async (staff) => {
    let { tstaffList, postFields, cartData, updateFields, hours, minutes } =
      this.state;
    console.log("handleSelect_Staff-Source_Codeid", this.state.updateFields);
    let { Room_Codeid, Source_Codeid, new_remark } = updateFields;
    let { work_point } = postFields;
    console.log("workpoint", this.props.workPoint);
    let data = {
      helper_id: staff.id,
    };
    if (cartData?.value?.type === "H") {
      let newHours = hours * 60 + minutes;
      await this.props
        //coursetmpitemhelper/?cart_id=5470&workcommpoints=0.00&done=2&deposit=680
        .commonCreateApi(
          `coursetmpitemhelper/?cart_id=${
            this.props.cartId
          }&workcommpoints=${work_point}&done=${
            // newHours === 0 ? 1 : newHours
            1
          }&deposit=${this.props.depositAmt}&dur_qty=${
            newHours === 0 ? 1 : newHours
          }`,
          data
        )
        .then((key) => {
          this.getCart1();
        });
    } else {
      let apiUrl = `coursetmpitemhelper/?cart_id=${this.props.cartId}&workcommpoints=${work_point}&done=${this.props.sessionCount}&deposit=${this.props.depositAmt}`;

      if (this.state.selectedClass) {
        apiUrl += `&sports_class=${this.state.selectedClass}`;
      }
      await this.props
        //coursetmpitemhelper/?cart_id=5470&workcommpoints=0.00&done=2&deposit=680
        .commonCreateApi(apiUrl, data)
        .then((key) => {
          this.getCart1();
        });
    }
  };
  getCart1 = () => {
    let {
      roomList,
      sourceList,
      staffList,
      cartData,
      duration,
      tstaffList,
      employeeOptions,
      hours,
      minutes,
    } = this.state;

    if (cartData?.value?.type === "H") {
      let newHours = hours * 60 + minutes;
      this.props
        .getCommonApi(
          `coursetmpitemhelper/?cart_id=${this.props.cartId}&done=${
            // newHours === 0 ? 1 : newHours
            1
          }&deposit=${this.props.depositAmt}`
        )
        .then(async (key) => {
          cartData = key;
          await this.setState({
            tstaffList: [],
            employeeOptions: [],
            sessionTableDetails: [],
          });
          tstaffList = key.data;
          let remainingPercentage = 100;
          let remainingAmount = Number(cartData.value.Price);

          tstaffList = key.data.map((list, index) => {
            let percent;

            // if (index === 0 && list.percent === "100") {
            //   percent = "100";
            // } else {
            percent = (remainingPercentage / (key.data.length - index)).toFixed(
              2
            );
            // list.percent !== ""
            //   ? list.percent
            //   : (remainingPercentage / (key.data.length - index)).toFixed(2);
            // }

            let workAmt = (remainingAmount / (key.data.length - index)).toFixed(
              2
            );
            // list.percent !== ""
            //   ? (remainingAmount * (percent / 100)).toFixed(2)
            //   : (remainingAmount / (key.data.length - index)).toFixed(2);

            remainingPercentage -= parseFloat(percent);
            remainingAmount -= parseFloat(workAmt);

            return {
              ...list,
              percent,
              work_amt: workAmt,
            };
          });
          employeeOptions = [];
          tstaffList.forEach((e) => {
            employeeOptions.push({ label: e.helper_name, value: e.helper_id });
          });
          this.setState({ cartData, tstaffList, employeeOptions }, () => {
            this.checkFirstArrayAndUpdateTiming();
          });
          this.getDataFromRes(key);
        });
    } else {
      this.props
        .getCommonApi(
          `coursetmpitemhelper/?cart_id=${this.props.cartId}&done=${this.props.sessionCount}&deposit=${this.props.depositAmt}`
        )
        .then(async (key) => {
          cartData = key;
          await this.setState({
            employeeOptions: [],
            sessionTableDetails: [],
          });
          tstaffList = key.data;
          let actualSession = parseFloat(this.props.sessionCount);
          let remainingPercentage = Number(this.props.sessionCount) * 100;
          let remainingAmount = Number(cartData.value.Price);
          let remainingSession = actualSession;
          let totalSessions = 0;
          console.log(remainingPercentage, "remaining");
          for (var i = 0; i < key.data.length; i++) {
            totalSessions += parseFloat(key?.data[i]?.session);
          }

          tstaffList = key.data.map((list, index) => {
            let percent;
            let session;

            session = (remainingSession / (key.data.length - index)).toFixed(2);
            percent = (remainingPercentage / (key.data.length - index)).toFixed(
              2
            );

            let workAmt = (remainingAmount / (key.data.length - index)).toFixed(
              2
            );

            remainingPercentage -= parseFloat(percent);
            remainingAmount -= parseFloat(workAmt);
            remainingSession -= parseFloat(session);
            return {
              ...list,
              percent,
              session,
              work_amt: workAmt,
            };
          });
          employeeOptions = [];
          tstaffList.forEach((e) => {
            employeeOptions.push({ label: e.helper_name, value: e.helper_id });
          });
          this.setState({ cartData, tstaffList, employeeOptions }, () => {
            this.checkFirstArrayAndUpdateTiming();
          });
          this.getDataFromRes(key);
        });
    }
    this.props
      .getCommonApi(
        `coursetmpitemhelper/?cart_id=${this.props.cartId}&done=${this.props.sessionCount}&deposit=${this.props.depositAmt}`
      )
      .then(async (key) => {
        cartData = key;
        await this.setState({
          tstaffList: [],
          employeeOptions: [],
          sessionTableDetails: [],
        });
        tstaffList = key.data;
        let remainingPercentage = 100;
        let remainingAmount = Number(cartData.value.Price);

        tstaffList = key.data.map((list, index) => {
          let percent;

          // if (index === 0 && list.percent === "100") {
          //   percent = "100";
          // } else {
          percent = (remainingPercentage / (key.data.length - index)).toFixed(
            2
          );
          // list.percent !== ""
          //   ? list.percent
          //   : (remainingPercentage / (key.data.length - index)).toFixed(2);
          // }

          let workAmt = (remainingAmount / (key.data.length - index)).toFixed(
            2
          );
          // list.percent !== ""
          //   ? (remainingAmount * (percent / 100)).toFixed(2)
          //   : (remainingAmount / (key.data.length - index)).toFixed(2);

          remainingPercentage -= parseFloat(percent);
          remainingAmount -= parseFloat(workAmt);

          return {
            ...list,
            percent,
            work_amt: workAmt,
          };
        });
        employeeOptions = [];
        tstaffList.forEach((e) => {
          employeeOptions.push({ label: e.helper_name, value: e.helper_id });
        });
        this.setState({ cartData, tstaffList, employeeOptions }, () => {
          this.checkFirstArrayAndUpdateTiming();
        });
        this.getDataFromRes(key);
      });
  };
  checkFirstArrayAndUpdateTiming = () => {
    let { tstaffList, cartData, updateFields } = this.state;
    // var item = tstaffList[0];
    let { Room_Codeid, Source_Codeid, new_remark } = updateFields;

    // let data = {};
    tstaffList.forEach((item) => {
      var today = new Date(),
        time = today.getHours() + ":" + today.getMinutes();
      let data = {
        appt_fr_time: this.roundTime(time, 10),
        add_duration: cartData.value.add_duration,
        wp1: item.wp1,
        session: item.session,
        percent: Number(item.percent),
        work_amt: Number(item.work_amt),
      };

      this.props
        //coursetmpitemhelper/129001/?Room_Codeid=&Source_Codeid=&new_remark=
        .commonPatchApi(
          `coursetmpitemhelper/${item.id}/?Room_Codeid=${Room_Codeid}&Source_Codeid=${Source_Codeid}&new_remark=${new_remark}`,
          data
        )
        .then(() => {});
    });
    this.getCart();
  };
  roundTime = (time, minutesToRound) => {
    let [hours, minutes] = time.split(":");
    hours = parseInt(hours);
    minutes = parseInt(minutes);

    // Convert hours and minutes to time in minutes
    time = hours * 60 + minutes;

    let rounded = Math.round(time / minutesToRound) * minutesToRound;
    let rHr = "" + Math.floor(rounded / 60);
    let rMin = "" + (rounded % 60);

    return rHr.padStart(2, "0") + ":" + rMin.padStart(2, "0");
  };
  handleUpdatChanges = async ({ target: { value, name } }) => {
    let { updateFields } = this.state;
    updateFields[name] = value;
    this.setState({
      updateFields,
    });
  };

  handlePostChanges = async ({ target: { value, name } }) => {
    let { postFields } = this.state;
    postFields[name] = value;
    this.setState({
      postFields,
    });
  };

  handleAddRow = () => {
    this.state.sessionTableDetails.push({ sessions: 0.0, values: [] });
    this.setState({});
  };

  handleRemoveRow = (index) => {
    let { sessionTableDetails } = this.state;
    if (index > -1) {
      sessionTableDetails.splice(index, 1);
    }
    this.setState({ sessionTableDetails });
  };

  handleSessionsChange = (e, index) => {
    let { sessionTableDetails } = this.state;
    sessionTableDetails[index].sessions = parseFloat(e.target.value);
    this.setState({ sessionTableDetails });
  };

  handleSessionEmpChange = (e, index) => {
    let { sessionTableDetails } = this.state;
    let values = [];
    e.forEach((e) => {
      values.push(e.value);
    });
    sessionTableDetails[index].values = values;
    this.setState({ sessionTableDetails });
  };

  calculateSessions = () => {
    let { sessionTableDetails, employeeOptions, tstaffList } = this.state;
    console.log(sessionTableDetails, employeeOptions, tstaffList, "Megalaaa");
    let sessionCount = 0;
    sessionTableDetails.forEach((e) => {
      sessionCount += e.sessions;
    });
    if (sessionCount > this.props.sessionCount) {
      Toast({ type: "error", message: "Session count cannot exceed!" });
      return;
    }
    let employeeStartCount = 1;
    employeeOptions.forEach((e) => {
      let total = 0.0;
      let employeeid = e.value;
      sessionTableDetails.forEach((sessionTable, index) => {
        let splitSessionAdjustCount = Number(
          sessionTableDetails[index].sessions /
            sessionTableDetails[index].values.length
        ).toFixed(2);
        let splitSessionreminder = Number(
          sessionTableDetails[index].sessions -
            splitSessionAdjustCount * sessionTableDetails[index].values.length
        ).toFixed(2);
        let includeSplitReminder =
          Number(splitSessionAdjustCount) + Number(splitSessionreminder);
        if (sessionTable.values.includes(e.value)) {
          let finalemployee = sessionTableDetails[index].values;
          let lastElement = finalemployee[finalemployee.length - 1];
          if (employeeid == lastElement) {
            total += includeSplitReminder;
            employeeStartCount = 1;
          } else {
            total = Number(total) + Number(splitSessionAdjustCount);
            employeeStartCount += 1;
          }
        }
      });

      tstaffList.filter((ele) => ele.helper_id == e.value)[0].session = total;
    });
    console.log(tstaffList, "list with sessions");
    this.setState({ tstaffList });

    let event = { target: { name: "session" } };
    tstaffList.forEach((item, index) => {
      this.handleUpdatestaff(event, item, index);
    });
  };
  // handleTreatementRemarks
  handleTreatementRemarks = (val) => {
    this.setState({ treatementRemarks: val });
  };

  //handleSearchStaff
  handleSearchStaff = async (event) => {
    await this.setState({ searchStaffInput: event.target.value });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async (event) => {
        let searchString = event.target.value;
        let data = { search: searchString };
        this.getStaffList(data);
      }, 500);
    }
    this.debouncedFn(event);
  };
  handleuUpdatePre = async (event, item, index) => {
    let count = 0;

    const { total_percentage } = this.state;

    // console.log(event, item, index,total_percentage,"durga xyz  1");

    if (Number(event.target.value)) {
      let { postFields, cartData = {} } = this.state;
      let { value = {} } = cartData;
      let { Item, Price } = value;
      let workpoint = Number(postFields.work_point);
      let userEnteredValue = Number(event.target.value);
      // if (workpoint >= userEnteredValue) {
      //   return false;
      // }
      let roundedValue = Number(Number(event.target.value).toFixed(2));
      console.log(
        roundedValue,
        "roundedValue roundedValue roundedValue roundedValue roundedValue"
      );
      let { tstaffList } = this.state;
      tstaffList[index][event.target.name] = roundedValue.toFixed(2);
      tstaffList[index]["work_amt"] = (Price * (roundedValue / 100)).toFixed(2);
      item.percent = roundedValue; // Modify the item.percent value directly
      console.log(tstaffList, "tstaffCheck");
      this.setState({
        percentage_calculate: (total_percentage * roundedValue) / 100,
      });

      //  count += total_percentage * roundedValue / 100;

      //  console.log(count, "Total count of percentage_calculate");

      await this.setState({
        tstaffList,
        updatedPercentValue: roundedValue, // Update the updatedPercentValue in the state
      });

      // console.log(event, item, index, "sfdgfdgsgf too");
      if (!this.debouncedFn) {
        this.debouncedFn = _.debounce(async (event, item, index) => {
          // console.log(event, item, index, "sfdgfdgsgf inside");
          this.handleUpdatestaff(
            event,
            item,
            index,
            this.state.percentage_calculate
          );
        }, 1000);
      }
      this.debouncedFn(event, item, index);
    }
  };
  handleuUpdatework_amt = async (event, item, index) => {
    const { total_percentage } = this.state;

    if (Number(event.target.value)) {
      let { postFields } = this.state;
      let workpoint = Number(postFields.work_point);
      let userEnteredValue = Number(event.target.value);
      if (workpoint >= userEnteredValue) {
        return false;
      }
      let roundedValue = Number(Number(event.target.value).toFixed(2));
      let { tstaffList } = this.state;
      tstaffList[index][event.target.name] = roundedValue;
      // item.work_amt = roundedValue; // Modify the item.percent value directly

      // let pricePrecent= total_percentage*roundedValue/100
      await this.setState({
        tstaffList,
        updatedWork_Am_tValue: roundedValue, // Update the updatedPercentValue in the state
      });

      // console.log(this.state.updatedWork_Am_tValue,"!!!!!!!!!!!!!!!!");
      // console.log(event, item, index, "sfdgfdgsgf too");
      if (!this.debouncedFn) {
        this.debouncedFn = _.debounce(async (event, item, index) => {
          // console.log(event, item, index, "sfdgfdgsgf inside");
          this.handleUpdatestaff(event, item, index);
        }, 1000);
      }
      this.debouncedFn(event, item, index);
    }
  };

  handleHoursChange = (e) => {
    const newHours = parseInt(e.target.value, 10) || 0;
    this.setState({ hours: newHours }, () => {
      this.getCart();
    });
  };

  handleMinutesChange = (e) => {
    const newMinutes = parseInt(e.target.value, 10) || 0;
    this.setState({ minutes: newMinutes }, () => {
      this.getCart();
    });
  };

  handleClassSelect = async ({ target: { value, name } }) => {
    this.setState({
      selectedClass: value,
    });
  };

  render() {
    let {
      staffList = [],
      tstaffList = [],
      roomList,
      Room,
      Source,
      duration,
      startDuration,
      sourceList,
      updateFields,
      headerDetails,
      cartData = {},
      postFields,
      employeeOptions,
      sessionTableDetails,
      sessionTableHeader,
      meta,
      hours,
      minutes,
    } = this.state;
    let { value = {} } = cartData;
    let { work_point } = postFields;
    let { Room_Codeid, Source_Codeid, new_remark } = updateFields;
    let {
      Item,
      Price,
      add_duration,
      room_id,
      room_name,
      source_id,
      source_name,
      times,
      type,
    } = value;
    let { tsStaff = {}, t } = this.props;
    let { course, unit_amount, workpoint } = tsStaff;
    return (
      <div className="row new-cart treatment-done" id="treatment-done-sesiions">
        <div className="col-12">
          <p className="fs-18 font-700 mb-3 title">{t("Treatment Done")}</p>
        </div>
        {type === "H" ? (
          <div className="col-8 mb-2 d-flex">
            <div className="col-6 mb-2">
              <label className="text-left text-black common-label-text ">
                {t("Item")}
              </label>
              <div className="input-group mb-2">{Item}</div>
              <label className="text-left text-black common-label-text ">
                {t("Price")}
              </label>
              <div className="input-group mb-2">{Price}</div>
              <label className="text-left text-black common-label-text ">
                {t("Work Point")}
              </label>

              <div className="input-group">
                <NormalInput
                  value={work_point ? work_point : ""}
                  name="work_point"
                  onChange={this.handlePostChanges}
                  className={`customer-name`}
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-6 d-flex flex-column justify-content-end mb-2">
              <p className="mb-2">Duration</p>
              <div className="d-flex justify-content-around">
                <div className="d-flex align-items-center">
                  <p className="mr-3">Hour</p>
                  <div className="w-50">
                    <NormalInput
                      type="text"
                      value={hours}
                      onChange={this.handleHoursChange}
                      className="w-100"
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center ">
                  <p className="mr-3">Minutes</p>
                  <div className="w-50">
                    <NormalInput
                      type="text"
                      value={minutes}
                      onChange={this.handleMinutesChange}
                      className="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-4 mb-2">
            <label className="text-left text-black common-label-text ">
              {t("Item")}
            </label>
            <div className="input-group mb-2">{Item}</div>
            <label className="text-left text-black common-label-text ">
              {t("Price")}
            </label>
            <div className="input-group mb-2">{Price}</div>
            <label className="text-left text-black common-label-text ">
              {t("Work Point")}
            </label>

            <div className="input-group">
              <NormalInput
                value={work_point ? work_point : ""}
                name="work_point"
                onChange={this.handlePostChanges}
                className={`customer-name`}
                disabled={true}
              />
            </div>
          </div>
        )}
        <div className="col-4 mb-2 d-flex align-items-end">
          {this.props.tokenDetails?.sportsclass && (
            <div className="col-md-12">
              <p className="mb-2 col-md-8">Select Class</p>
              <div className="d-flex col-md-8">
                <div className="d-flex align-items-center w-100">
                  <NormalSelect
                    options={this.state.classOptions}
                    value={this.state.selectedClass}
                    name="selectedClass"
                    onChange={this.handleClassSelect}
                    className="customer-name py-0"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="col-2 mb-2">
          <label className="text-left text-black common-label-text ">
            {t("Session")}
          </label>
          <h1> {this.props.sessionCount}</h1>

          {/* <h1>{(selectedTreatments.itemflexiservice && selectedTreatments.b21flexitype) ? this.state.selectedFlexiPointValueFromTreatmentPage : this.props.session}</h1> */}
        </div>

        <div className="col-12 col-md-3">
          <label className="text-left text-black common-label-text ">
            {t("Treatment Remarks")}
          </label>
          {this.props.tokenDetails.ipadkey ? (
            <SearchInputKeyboard
              onRef={(ref) => (this.childRemarkInput = ref)}
              onChangeTextInput={(e) => this.handleTreatementRemarks(e)}
              focusValue={"remarks"}
              placeHolderText={""}
              isSearchIcon={false}
              parentPassIntialValue={this.state.treatementRemarks}
            />
          ) : (
            // Changes by Praveen
            <NormalTextarea
              placeholder="enter remarks"
              value={this.state.treatementRemarks}
              name="treatementRemarks"
              onChange={(e) => this.handleTreatementRemarks(e.target.value)}
              className={`form-control`}
            />
          )}
        </div>

        <div className="col-12 col-md-4 ">
          <label className="text-left text-black common-label-text ">
            {t("Search staff")}
          </label>

          <NormalInput
            placeholder="enter staff"
            value={this.state.searchStaffInput}
            name="searchStaffInput"
            className="form-control"
            onChange={(e) => this.handleSearchStaff(e)}
          />
        </div>
        <div className={`col-12 cart-item emp-image`}>
          <StaffList
            staffList={staffList}
            meta={meta}
            handleNext={() => this.handleNext()}
            handleBack={() => this.handleBack()}
            handleSelectedStaff={(item) => this.handleSelect_Staff(item)}
          />
        </div>
        <div className={`col-12 cart-item`}>
          <div className={`item-list`}>
            <div className="table">
              <TableWrapper
                headerDetails={headerDetails}
                queryHandler={this.handlePagination}
                // pageMeta={pageMeta}
                // isEmpty={tstaffList.length === 0 ? true:false}
              >
                {tstaffList && tstaffList.length > 0
                  ? tstaffList.map((item, index) => {
                      console.log(item, "itemTest");
                      const calculateSession = hours * 60 + minutes;
                      const newSession = calculateSession / tstaffList.length;
                      return (
                        <tr key={index}>
                          <td className="position-relative status-type">
                            <div className="text-left fs-20">
                              {item.helper_name}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              {this.props.tokenDetails.ipadkey ? (
                                <NumPadKeyboard
                                  onChange={(val) => {
                                    let event = {
                                      target: {
                                        name: "session",
                                        value: val,
                                      },
                                    };
                                    this.handleUpdateSession(
                                      event,
                                      item,
                                      index
                                    );
                                  }}
                                  value={item.session}
                                />
                              ) : (
                                <NormalInput
                                  // placeholder="Enter here"
                                  // options={siteList}
                                  value={
                                    cartData?.value?.type === "H"
                                      ? newSession
                                      : item.session
                                  }
                                  name="session"
                                  type="number"
                                  min="0"
                                  max={this.props.sessionCount}
                                  onChange={(e) =>
                                    this.handleUpdateSession(e, item, index)
                                  }
                                  // onBlur={(e) =>
                                  //   this.handleUpdatestaff(e, item, index)
                                  // }
                                  className="text-right w-100"
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              {this.props.tokenDetails.ipadkey ? (
                                <NumPadKeyboard
                                  onChange={(val) => {
                                    let event = {
                                      target: {
                                        name: "wp1",
                                        value: val,
                                      },
                                    };
                                    this.handleuUpdateWp(event, item, index);
                                  }}
                                  value={item.wp1}
                                />
                              ) : (
                                <NormalInput
                                  // placeholder="Enter here"
                                  // options={siteList}
                                  value={item.wp1}
                                  name="wp1"
                                  type="number"
                                  min="0"
                                  max={postFields.work_point}
                                  onChange={(e) =>
                                    this.handleuUpdateWp(e, item, index)
                                  }
                                  // onBlur={(e) =>
                                  //   this.handleUpdatestaff(e, item, index)
                                  // }
                                  className="text-right w-100"
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              {this.props.tokenDetails.ipadkey ? (
                                <NumPadKeyboard
                                  onChange={(val) => {
                                    let event = {
                                      target: {
                                        name: "percent",
                                        value: val,
                                      },
                                    };
                                    this.handleuUpdatePre(event, item, index);
                                  }}
                                  value={item.percent}
                                />
                              ) : (
                                <NormalInput
                                  // placeholder="Enter here"
                                  // options={siteList}
                                  value={item.percent}
                                  name="percent"
                                  type="number"
                                  max={100}
                                  onChange={(e) => {
                                    if (
                                      Number(e.target.value) >= 0 &&
                                      Number(e.target.value) <= 100
                                    ) {
                                      this.handleuUpdatePre(e, item, index);
                                    }
                                  }}
                                  // onBlur={(e) => this.handleUpdatestaff(e, item, index)}
                                  className="text-right w-100"
                                />
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              {this.props.tokenDetails.ipadkey ? (
                                <NumPadKeyboard
                                  onChange={(val) => {
                                    let event = {
                                      target: {
                                        name: "work_amt",
                                        value: val,
                                      },
                                    };
                                    this.handleuUpdatework_amt(
                                      event,
                                      item,
                                      index
                                    );
                                  }}
                                  value={item.work_amt}
                                />
                              ) : (
                                <NormalInput
                                  // placeholder="Enter here"
                                  // options={siteList}
                                  value={item.work_amt}
                                  name="work_amt"
                                  type="number"
                                  min="0"
                                  max={postFields.work_point}
                                  onChange={(e) =>
                                    this.handleuUpdatework_amt(e, item, index)
                                  }
                                  // onBlur={(e) =>
                                  //   this.handleUpdatestaff(e, item, index)
                                  // }
                                  className="text-right w-100"
                                />
                              )}
                            </div>
                          </td>
                          {/* <td>
                          {this.state.hideNotNeededControls == "true" && (
                            <div className="d-flex align-items-center justify-content-center">
                              <div className="input-group">
                                <NormalSelect
                                  // placeholder="Enter here"
                                  options={startDuration}
                                  value={item.appt_fr_time}
                                  name="appt_fr_time"
                                  onChange={(e) =>
                                    this.handleUpdatestaff(e, item, index)
                                  }
                                  className="customer-name py-0"
                                />
                              </div>
                            </div>
                          )}
                        </td>
                        <td>
                          {this.state.hideNotNeededControls == "true" && (
                            <div className="text-right">
                              {item.appt_to_time}
                            </div>
                          )}
                        </td>

                        <td>
                          {this.state.hideNotNeededControls == "true" && (
                            <div className="d-flex align-items-center justify-content-center">
                              <div className="input-group">
                                <NormalSelect
                                  // placeholder="Enter here"this.setState({add_duration:e.target.value})
                                  options={duration}
                                  value={item.add_duration}
                                  name="add_duration"
                                  onChange={(e) =>
                                    this.handleUpdatestaff(e, item, index)
                                  }
                                  className="customer-name p-0"
                                />
                              </div>
                            </div>
                          )}
                        </td> */}
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            </div>
          </div>
        </div>

        <div className="col-12 cart-item">
          <Tree content="Assign Sessions">
            <div className="item-list p-0">
              <div className="d-flex justify-content-end">
                <div className="col-md-4 p-0 mb-2">
                  <NormalButton
                    mainbg={true}
                    label="Add Row"
                    onClick={this.handleAddRow}
                  />
                </div>
              </div>
              <div className="table">
                <TableWrapper headerDetails={sessionTableHeader}>
                  {sessionTableDetails && sessionTableDetails.length > 0
                    ? sessionTableDetails.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <NormalInput
                                  // placeholder="Enter here"
                                  // options={siteList}
                                  value={item.sessions}
                                  name="session"
                                  type="number"
                                  min="0"
                                  max={this.props.sessionCount}
                                  onChange={(e) =>
                                    this.handleSessionsChange(e, index)
                                  }
                                  //className="wpr"
                                  className="text-right"
                                />
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <NormalMultiSelect
                                  // placeholder="Enter here"
                                  target={document.getElementById(
                                    "treatment-done-sesiions"
                                  )}
                                  options={employeeOptions}
                                  value={item.values}
                                  handleMultiSelect={(e) =>
                                    this.handleSessionEmpChange(e, index)
                                  }
                                  //className="wpr"
                                />
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <div
                                  className="icon"
                                  onClick={() => this.handleRemoveRow(index)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    fill="red"
                                    class="bi bi-x"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                  </svg>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </TableWrapper>
              </div>
              {sessionTableDetails?.length > 0 ? (
                <div className="d-flex justify-content-end">
                  <div className="col-md-4 p-0 mt-2">
                    <NormalButton
                      mainbg={true}
                      label="Assign Sessions"
                      onClick={this.calculateSessions}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </Tree>
        </div>

        <div className="col-12 mb-2">
          {this.state.hideNotNeededControls == "true" && (
            <div className="row">
              <div className="col-4">
                <label className="text-left text-black common-label-text ">
                  {t("Room")}
                </label>

                <div className="input-group">
                  <NormalSelect
                    // placeholder="Enter here"
                    options={roomList}
                    value={Room_Codeid}
                    name="Room_Codeid"
                    onChange={this.handleUpdatChanges}
                    className="customer-name py-0"
                    // disabled={Room_Codeid}
                  />
                </div>
              </div>
              <div className="col-4">
                <label className="text-left text-black common-label-text ">
                  {t("Source")}
                </label>

                <div className="input-group">
                  <NormalSelect
                    // placeholder="Enter here"
                    options={sourceList}
                    value={Source_Codeid}
                    name="Source_Codeid"
                    onChange={this.handleUpdatChanges}
                    className="customer-name py-0"
                    // disabled={Source_Codeid}
                  />
                </div>
              </div>

              <div className="col-4">
                <label className="text-left text-black common-label-text ">
                  {t("New Remark")}
                </label>

                <div className="input-group">
                  <NormalInput
                    // placeholder="Enter here"
                    // options={siteList}
                    value={new_remark}
                    name="new_remark"
                    onChange={this.handleUpdatChanges}
                    className="customer-name"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="col-12 pt-4 action-bar">
          <div className="row">
            <div className="col-6 d-flex">
              <NormalButton
                buttonClass={"mx-2"}
                resetbg={true}
                className="fs-15"
                label="Clear Line"
                outline={false}
                onClick={this.handleClearLine}
              />
              <NormalButton
                buttonClass={"mx-2"}
                resetbg={true}
                className="fs-15"
                label="Clear All"
                outline={false}
                onClick={this.handleClearAll}
              />
            </div>
            <div className="col-4 text-right">
              {/* <NormalButton
                                buttonClass={"mx-2"}
                                danger={true}
                                className=" fs-15 close"
                                label="Close"
                                outline={false}
                                onClick={this.props.handleModal}
                            /> */}
            </div>
            <div className="col-2 text-right">
              <NormalButton
                buttonClass={"mx-2"}
                mainbg={true}
                className=" fs-15 confirm"
                label="Confirm"
                outline={false}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selected_cstomer: state.common.selected_cstomer,
  basicApptDetail: state.appointment.basicApptDetail,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // getCustomer,
      getCommonApi,
      updateForm,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
      CustomerGroups,
    },
    dispatch
  );
};

export const CourseTreatmentDone = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(CourseTreatmentDoneClass)
);
